import type { GetSitesResponse } from "@/types/openapi-ts";

export interface SiteSettingsState {
  data: Record<string, GetSitesResponse['payload'][number]>
}

export default {
  data: {},
};
